<mat-form-field>
  <mat-label>{{ ("mobility" | i18n) || "Mobilität" | titlecase }}</mat-label>
  <mat-select
    [ngModel]="selectedValue$ | async"
    (selectionChange)="selectionChanged($event.value)"
    name="carSelect"
    [disabled]="!!(isDisabled$ | async)"
    data-cy="mobility-select">
    <mat-option [value]="null">- </mat-option>
    <mat-option
      *ngFor="let carLicense of carLicenseEnum | enumToArray"
      [value]="carLicenseEnum[carLicense]">
      {{
        ("carLicenseEnum." + carLicenseEnum[carLicense] | i18n) || carLicense
      }}
    </mat-option>
  </mat-select>
  <mat-hint
    align="end"
    *ngIf="hintContent">
    <ng-container *ngTemplateOutlet="hintContent"></ng-container>
  </mat-hint>
</mat-form-field>
